<app-iota-modal i18n-title title="Edit license validity" [modalOptions]="modalOptions" (close$)="closeDialog()">
    <div modal-body class="w-full">
        <div class="w-full flex flex-col gap-5">
            <app-platform-license-activation-form
                [platformLicenseActivation]="licenseActivation$ | ngrxPush"
                [editMode]="true"
                (formValid)="dateFormValid = $event"
                #platformLicenseActivationForm
            >
            </app-platform-license-activation-form>

            <div class="alert alert-error" *ngIf="!(actionLoading$ | ngrxPush) && (actionError$ | ngrxPush)">
                <iota-icon icon="exclamation-triangle" size="1.5"></iota-icon>
                <span class="w-full" i18n>Error while updating the license activation!</span>
            </div>
        </div>
    </div>

    <ng-container modal-footer>
        <div class="w-full flex flex-row items-center justify-between gap-5">
            <button class="btn btn-sm btn-ghost rounded-full flex flex-row items-center gap-2" (click)="closeDialog()">
                <span i18n>Cancel</span>
            </button>

            <button
                class="btn btn-sm btn-primary rounded-full flex flex-row items-center gap-2"
                [ngClass]="{ loading: actionLoading$ | ngrxPush }"
                [disabled]="!dateFormValid"
                (click)="updateLicenseActivation()"
            >
                <span i18n>Save</span>
            </button>
        </div>
    </ng-container>
</app-iota-modal>
